export const GRV_DETRO = 0
export const GRV_POLICIA_CIVIL = 1
export const PROCESSO_SALVADOS = 2
export const GRV_ESPIRITO_SANTO = 3
export const GRV_PREFEITURA = 4
export const GRV_CAMPOS_DOS_GOYTACAZES = 5

const labels = {
  [GRV_DETRO]: 'DETRO',
  [GRV_POLICIA_CIVIL]: 'Polícia Civil',
  [GRV_ESPIRITO_SANTO]: 'Espírito Santo',
  [GRV_PREFEITURA]: 'Prefeitura Barra do Piraí',
  [GRV_CAMPOS_DOS_GOYTACAZES]: 'Campos dos Goytacazes'
}

export function getLabel (tipo) {
  return labels[tipo] || '-'
}

export const PATIO_CAMPO_GRANDE = 1
export const PATIO_DEODORO = 2
export const PATIO_VARGEM_GRANDE = 3
export const PATIO_VILA_VELHA = 4
export const PATIO_CAMPOS_DE_GOYTACAZES = 5
export const PATIO_CENTRAL_DETRAN_ES = 6
export const PATIO_CACHOEIRO = 8
export const PATIO_ENGENHO_DA_RAINHA = 9
export const PATIO_VARGEM_GRANDE_APL = 10
export const PATIO_APL_TRANSBORDO = 11
export const PATIO_BARRA_PIRAI = 12
export const PATIO_APL_SEROPEDICA = 13
export const PATIO_APL_LEOPOLDINA = 15
export const PATIO_APL_MANGARATIBA = 16
export const PATIO_APL_VASSOURAS = 17
export const PATIO_APL_CAMPOS_DOS_GOYTACAZES = 18
export const PATIO_CASIMIRO_DE_ABREU = 20
export const PATIO_VIRTUAL_PMERJ = 21
export const PATIO_APL_SAO_PEDRO_ALDEIA = 22
export const PATIO_RPC_VARGEM_GRANDE = 23
export const PATIO_RPC_SEROPEDICA = 24
export const PATIO_RPC_LEOPOLDINA = 25
export const PATIO_RPC_VASSOURAS = 26
export const PATIO_RPC_CAMPOS_DOS_GOYTACAZES = 27
export const PATIO_NOVA_IGUACU = 28

export function getPatiosPorTipo (tipo) {
  return PATIOS_TIPO_GRV[tipo] || [
    PATIO_CAMPO_GRANDE,
    PATIO_DEODORO,
    PATIO_VARGEM_GRANDE,
    PATIO_VILA_VELHA,
    PATIO_CACHOEIRO,
    PATIO_CAMPOS_DE_GOYTACAZES,
    PATIO_ENGENHO_DA_RAINHA,
    PATIO_VARGEM_GRANDE_APL,
    PATIO_APL_TRANSBORDO,
    PATIO_BARRA_PIRAI,
    PATIO_APL_SEROPEDICA,
    PATIO_APL_LEOPOLDINA,
    PATIO_APL_MANGARATIBA,
    PATIO_APL_VASSOURAS,
    PATIO_APL_CAMPOS_DOS_GOYTACAZES,
    PATIO_CASIMIRO_DE_ABREU,
    PATIO_VIRTUAL_PMERJ,
    PATIO_APL_SAO_PEDRO_ALDEIA,
    PATIO_RPC_VARGEM_GRANDE,
    PATIO_RPC_LEOPOLDINA,
    PATIO_RPC_VASSOURAS,
    PATIO_RPC_CAMPOS_DOS_GOYTACAZES,
    PATIO_NOVA_IGUACU
  ]
}
const PATIOS_TIPO_GRV = {
  [GRV_DETRO]: [
    PATIO_CAMPO_GRANDE,
    PATIO_DEODORO,
    PATIO_VARGEM_GRANDE,
    PATIO_CAMPOS_DE_GOYTACAZES,
    PATIO_ENGENHO_DA_RAINHA,
    PATIO_VARGEM_GRANDE_APL,
    PATIO_APL_TRANSBORDO,
    PATIO_APL_SEROPEDICA,
    PATIO_BARRA_PIRAI,
    PATIO_APL_LEOPOLDINA,
    PATIO_APL_MANGARATIBA,
    PATIO_APL_VASSOURAS,
    PATIO_APL_CAMPOS_DOS_GOYTACAZES,
    PATIO_APL_SAO_PEDRO_ALDEIA,
    PATIO_RPC_VARGEM_GRANDE,
    PATIO_RPC_LEOPOLDINA,
    PATIO_RPC_VASSOURAS,
    PATIO_RPC_CAMPOS_DOS_GOYTACAZES,
    PATIO_NOVA_IGUACU
  ],
  [GRV_PREFEITURA]: [
    PATIO_CAMPO_GRANDE,
    PATIO_DEODORO,
    PATIO_VARGEM_GRANDE,
    PATIO_CAMPOS_DE_GOYTACAZES,
    PATIO_ENGENHO_DA_RAINHA,
    PATIO_VARGEM_GRANDE_APL,
    PATIO_APL_TRANSBORDO,
    PATIO_APL_SEROPEDICA,
    PATIO_BARRA_PIRAI,
    PATIO_APL_LEOPOLDINA,
    PATIO_APL_MANGARATIBA,
    PATIO_APL_VASSOURAS,
    PATIO_APL_CAMPOS_DOS_GOYTACAZES,
    PATIO_CASIMIRO_DE_ABREU,
    PATIO_VIRTUAL_PMERJ,
    PATIO_RPC_CAMPOS_DOS_GOYTACAZES,
    PATIO_NOVA_IGUACU
  ],
  [GRV_CAMPOS_DOS_GOYTACAZES]: [
    PATIO_CAMPO_GRANDE,
    PATIO_DEODORO,
    PATIO_VARGEM_GRANDE,
    PATIO_CAMPOS_DE_GOYTACAZES,
    PATIO_ENGENHO_DA_RAINHA,
    PATIO_VARGEM_GRANDE_APL,
    PATIO_APL_TRANSBORDO,
    PATIO_APL_SEROPEDICA,
    PATIO_BARRA_PIRAI,
    PATIO_APL_LEOPOLDINA,
    PATIO_APL_MANGARATIBA,
    PATIO_APL_VASSOURAS,
    PATIO_APL_CAMPOS_DOS_GOYTACAZES,
    PATIO_RPC_VARGEM_GRANDE,
    PATIO_RPC_LEOPOLDINA,
    PATIO_RPC_VASSOURAS,
    PATIO_RPC_CAMPOS_DOS_GOYTACAZES,
    PATIO_NOVA_IGUACU
  ],
  [GRV_POLICIA_CIVIL]: [
    PATIO_CAMPO_GRANDE,
    PATIO_DEODORO,
    PATIO_VARGEM_GRANDE,
    PATIO_VARGEM_GRANDE_APL,
    PATIO_APL_TRANSBORDO,
    PATIO_APL_SEROPEDICA,
    PATIO_BARRA_PIRAI,
    PATIO_APL_LEOPOLDINA,
    PATIO_APL_MANGARATIBA,
    PATIO_APL_VASSOURAS,
    PATIO_APL_CAMPOS_DOS_GOYTACAZES,
    PATIO_RPC_VARGEM_GRANDE,
    PATIO_RPC_LEOPOLDINA,
    PATIO_RPC_VASSOURAS,
    PATIO_RPC_CAMPOS_DOS_GOYTACAZES,
    PATIO_NOVA_IGUACU
  ],
  [GRV_ESPIRITO_SANTO]: [
    PATIO_VILA_VELHA,
    PATIO_CACHOEIRO
  ]
}



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/tipos-grv.js